import React, { useEffect } from 'react';
import { twMerge } from 'utilities/src/twMerge';

import { type MobileMenuProps } from './_props';

import useMobileHeaderTheme from './themes';
import MobileMenuListSection from './MobileMenuListSection';

/**
 * MobileMenu Component
 */

function MobileMenu({
  isMobileMenuOpen,
  menuItems,
  CtaButton,
  mobileSectionTitle,
  mobileSecondarySectionTitle,
  secondaryMenuItems,
  classes,
}: MobileMenuProps) {
  const { mobileMenuClasses, mobileMenuThemeClasses, mobileMenuNavClasses, mobileMenuSectionDividerClasses } =
    useMobileHeaderTheme();

  useEffect(() => {
    document.body.style.overflowY = isMobileMenuOpen ? 'hidden' : 'auto';
    return () => {
      document.body.style.overflowY = 'auto';
    };
  }, [isMobileMenuOpen]);

  if (!isMobileMenuOpen) return null;

  return (
    <section className={twMerge(mobileMenuClasses, mobileMenuThemeClasses, classes)}>
      <nav className={mobileMenuNavClasses}>
        <MobileMenuListSection menuItems={menuItems} mobileSectionTitle={mobileSectionTitle} />
        {CtaButton}
        {secondaryMenuItems && (
          <>
            <div className="h-0 w-full px-4">
              <div className={mobileMenuSectionDividerClasses} />
            </div>
            <MobileMenuListSection
              menuItems={secondaryMenuItems}
              mobileSectionTitle={mobileSecondarySectionTitle}
            />
          </>
        )}
      </nav>
    </section>
  );
}

/**
 * Exports
 */

export default MobileMenu;
